import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { API } from '../../constants/api';
import { User } from '../../models/auth/user.model';

@Injectable({
  providedIn: 'root',
})
export class UsersService {
  constructor(private httpClient: HttpClient) {}

  getAll(): Observable<User[]> {
    return this.httpClient.get<User[]>(API.USERS).pipe(catchError((error) => throwError(error)));
  }

  upsert(user: User): Observable<User> {
    return this.httpClient
      .post<User>(API.USER_UPSERT, user)
      .pipe(catchError((error) => throwError(error)));
  }

  delete(id: number): Observable<any> {
    return this.httpClient
      .delete(`${API.USERS}/${id}`)
      .pipe(catchError((error) => throwError(error)));
  }
}
